export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-24.22a6cd8d.png";